module.exports = __webpack_public_path__ + "static/media/jalapeno-lime-mobile-fr.0b3c94bf.jpg";